import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectDialog, clearDialog } from 'getaway-data-layer';
import {
  List,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  Button,
  Divider,
} from '@mui/material';
import MUIDialog from '@mui/material/Dialog';
import './Dialog.less';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useQuery } from '../../../hooks/useQuery';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-ignore
  return <Slide direction="up" ref={ref} {...props} />;
});

export type DialogOption = {
  title: string | React.ReactElement;
  selected?: boolean;
  action?: () => void;
  icon?: string;
};

const Dialog = () => {
  const dispatch = useDispatch();
  const query = useQuery();
  const isWidget = query?.get('mode') === 'widget';
  const selectedDialog = useSelector(selectDialog) as any;

  const handleYesAction = () => {
    if (selectedDialog.yesAction instanceof Function) {
      selectedDialog.yesAction();
    }
    dispatch(clearDialog());
  };

  const handleNoAction = () => {
    if (selectedDialog?.noAction) {
      selectedDialog.noAction();
    }
    dispatch(clearDialog());
  };

  const handleClose = () => {
    dispatch(clearDialog());
    handleNoAction();
  };

  return (
    selectedDialog && (
      <MUIDialog
        open={!!selectedDialog}
        // @ts-ignore
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullScreen={isWidget && !selectedDialog?.options}
      >
        <div
          style={
            isWidget && !selectedDialog?.options
              ? {
                  height: '100%',
                  padding: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                }
              : {}
          }
        >
          <DialogTitle>{selectedDialog.title}</DialogTitle>
          {selectedDialog.message && (
            <DialogContent>
              <DialogContentText
                data-testid="Dialog-dialogMessage"
                id="alert-dialog-slide-description"
              >
                <Markdown rehypePlugins={[rehypeRaw]}>
                  {selectedDialog.message}
                </Markdown>
              </DialogContentText>
            </DialogContent>
          )}
          {selectedDialog?.actionComponent && selectedDialog?.actionComponent()}
          {selectedDialog?.options && <Divider />}
          <DialogActions
            data-testid="Dialog-dialogAction"
            sx={{ justifyContent: 'flex-start' }}
          >
            {selectedDialog?.options ? (
              <List
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  paddingRight: 10,
                  paddingLeft: 10,
                }}
              >
                {selectedDialog?.options?.map((option: DialogOption) => (
                  <div
                    data-testid={`Dialog-dialogOption-${option.title}`}
                    className="dialog-list-action"
                    key={option.title.toString()}
                    onClick={
                      option?.action
                        ? () => {
                            // @ts-ignore
                            option.action();
                            handleClose();
                          }
                        : handleClose
                    }
                    style={
                      option?.selected
                        ? {
                            color: 'black',
                          }
                        : {}
                    }
                  >
                    {option?.icon !== undefined && (
                      <img
                        alt={option?.icon}
                        src={option?.icon}
                        style={{
                          width: 16,
                          height: 11,
                          border: '0.5px solid grey',
                        }}
                      />
                    )}
                    {option.title}
                  </div>
                ))}
              </List>
            ) : (
              <div className="dialog-button-wrapper">
                {selectedDialog?.yesActionText && (
                  <Button
                    data-testid="Dialog-topBtn"
                    style={
                      selectedDialog?.isDestructive ? { color: 'red' } : {}
                    }
                    onClick={handleYesAction}
                  >
                    {selectedDialog.yesActionText}
                  </Button>
                )}
                <Button
                  data-testid="Dialog-cancelBtn"
                  style={
                    selectedDialog?.isDestructive ? { fontWeight: 'bold' } : {}
                  }
                  onClick={handleNoAction}
                >
                  {selectedDialog.noActionText}
                </Button>
              </div>
            )}
          </DialogActions>
        </div>
      </MUIDialog>
    )
  );
};

export default Dialog;
